import React from 'react';
import { Box, Button, makeStyles, Typography } from "@material-ui/core";
import alertaStyles from "./Alerta.styles";
import EmergencyIcon from '../icons/EmergencyIcon';
import botaoStyles from './Botao.styles';

const useStyles = makeStyles((theme) => ({
    alertBox: {
        ...alertaStyles.alertBox,
        justifyContent: 'space-between',
        gap: '1rem',
        backgroundColor: '#f7ede7',
    },
    alertTitle: {
        ...alertaStyles.alertTitle,
        fontSize: '18px',
    },
    alertSubtitle: {
        ...alertaStyles.alertSubtitle,
        fontSize: '16px',
    },
    button: {
        ...botaoStyles
    }
}));

const AlertaRetiradaPendente = ({ handleRetirarPedidoAbbiamo }) => {
    const classes = useStyles();

    return (
        <Box className={classes.alertBox}>
            <EmergencyIcon color='errorDark' />
            <Box display={'flex'} flexDirection={'column'} flex={1}>
                <Typography variant="inherit" className={classes.alertTitle}>
                    Pedido pendente de confirmação de retirada!
                </Typography>
                <Typography variant="caption" className={classes.alertSubtitle}>
                    Confirme a retirada deste pedido. Caso não tenha sido feita pelo entregador, <strong>cancele o pedido após 3 dias.</strong>
                </Typography>
            </Box>
            <Box display={'flex'} alignItems={'center'}>
                <Button variant='contained' className={classes.button} onClick={handleRetirarPedidoAbbiamo}>confirmar retirada</Button>
            </Box>
        </Box>
    );
};

export default AlertaRetiradaPendente;